import React from "react";

export function PrivacyPolicy() {
  return (
    <div className="bg-obsidian text-slate-100 min-h-screen py-24 px-4 sm:px-6 lg:px-12">
      <div className="max-w-3xl mx-auto space-y-6 text-left">
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white">Privacy Policy</h1>
        <p className="text-sm text-slate-400 font-mono">Last Updated: December 2025</p>
        <p className="text-slate-300 text-sm leading-relaxed">
          At Career Influencer Hub, we respect your professional credentials and privacy. We secure all personal information, contact parameters, and business goals with absolute confidentiality.
        </p>
        <p className="text-slate-300 text-sm leading-relaxed">
          We collect name, email, and professional titles during course signups and template downloads to offer you relevant updates. We never distribute your parameters to any third-party systems.
        </p>
      </div>
    </div>
  );
}

export function TermsConditions() {
  return (
    <div className="bg-obsidian text-slate-100 min-h-screen py-24 px-4 sm:px-6 lg:px-12">
      <div className="max-w-3xl mx-auto space-y-6 text-left">
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white">Terms &amp; Conditions</h1>
        <p className="text-sm text-slate-400 font-mono">Last Updated: December 2025</p>
        <p className="text-slate-300 text-sm leading-relaxed">
          Welcome to the premium digital marketing platform of Suhasini Basa (suhasinibasa.com). By accessing our services, checklists, and guides, you accept these operational terms.
        </p>
        <p className="text-slate-300 text-sm leading-relaxed">
          All curriculum materials, script configurations, checklists, and visual structures are the exclusive intellectual property of Suhasini Basa. Reselling or public redistribution is strictly prohibited.
        </p>
      </div>
    </div>
  );
}

export function RefundPolicy() {
  return (
    <div className="bg-obsidian text-slate-100 min-h-screen py-24 px-4 sm:px-6 lg:px-12">
      <div className="max-w-3xl mx-auto space-y-6 text-left">
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white">Refund Policy</h1>
        <p className="text-sm text-slate-400 font-mono">Last Updated: December 2025</p>
        <p className="text-slate-300 text-sm leading-relaxed">
          Our programs, templates, checklists, and mastermind services are professional tools designed for serious implementation.
        </p>
        <p className="text-slate-300 text-sm leading-relaxed">
          L0 Fast Start downloads and membership materials are available immediately upon purchase, and therefore are non-refundable. For higher coaching and mastermind tiers, cancellations must align with our signed commitment letters.
        </p>
      </div>
    </div>
  );
}
